/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  unref
} from 'vue';

import type {
  LimitsResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Get pricing limits table
 */
export const getLimits = (

 signal?: AbortSignal
) => {


      return axiosClient<LimitsResponse>(
      {url: `/b2c/limits`, method: 'GET', signal
    },
      );
    }




export const getGetLimitsQueryKey = () => {
    return [
    'b2c','limits'
    ] as const;
    }


export const getGetLimitsQueryOptions = <TData = Awaited<ReturnType<typeof getLimits>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLimits>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetLimitsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLimits>>> = ({ signal }) => getLimits(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLimits>>, TError, TData>
}

export type GetLimitsQueryResult = NonNullable<Awaited<ReturnType<typeof getLimits>>>
export type GetLimitsQueryError = ErrorType<unknown>


/**
 * @summary Get pricing limits table
 */

export function useGetLimits<TData = Awaited<ReturnType<typeof getLimits>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLimits>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLimitsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






